<template>
  <div class="cschatthai">
<div class="hidden-sm-and-down">
	<header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">การรับข้อมูลคิวอาร์โค้ดจาก Bottom Menu</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เมื่อทาง OneChat ได้รับข้อความจาก ผู้ใช้ที่ทำการส่งถึงบอทที่ลงทะเบียน webhook กับทางเรา เราจะส่งข้อมูลที่จำเป็นไปยัง webhook ตามข้อมูลต่อไปนี้</p>
    </div>
    <span>ตัวอย่างรูปแบบ Webhook ที่ Bot จะได้เมื่อ User scan Qrcode</span>
<div>
    <div class="MarkdownContent hidden-sm-and-down">
      <code class="codecolor mt-2" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"event"</span> : <span class="colorvalue">"qrcode"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">"1462629479859"</span>,
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"user"</span>,
        <span class="colorkey">"user_id"</span> : <span class="colorvalue">"R5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
        <span class="colorkey">"one_id"</span> : <span class="colorvalue">"123xxxx"</span>,
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>
    },
    <span class="colorkey">"data"</span> : <span class="colorvalue">"Hello"</span>
  }
      </code>

      <h3>รายละเอียดข้อมูลที่ได้รับ</h3>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของ Bot ที่เป็นผู้รับ Webhook ที่ส่งไปให้</td>
        </tr>
        <tr>
          <td>event</td>
          <td>String</td>
          <td>ชื่อการกระทำของ User ที่ทำให้เกิด Webhook<br>
          <!-- <ul>  <li>add_friend เป็นอีเว้นท์เมื่อมีการเพิ่มเพื่อนกับบอท</li></ul> -->
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>เวลาที่ส่ง Webhook</td>
        </tr>
        <tr>
          <td>source</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลของ user ที่สแกน ประกอบด้วยข้อมูลดังนี้
            <ul>
                <li>type_source ชนิดของผู้ใช้ ซึ่งจะเป็น user</li>
                <li>user_id คือรหัสเฉพาะของผู้ใช้ในระบบ Onechat</li>
                <li>one_id คือ OneID ของผู้ใช้</li>
                <li>email คืออีเมล์ของผู้ใช้</li>
                <li>display_name คือชื่อของผู้ใช้ที่แสดงงในระบบ Onechat</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>data</td>
          <td>String</td>
          <td>ข้อมูลที่อ่านได้จากการสแกน QrCode</td>
        </tr>
      </table>
    </div>

    </div>

</div>
<!-- mobile -->
<div class="hidden-md-and-up" >
  <header class="ArticleMainHeader" style="margin-top: 5vh;">
      <h1 class="ArticleMainTitle">การรับข้อมูลคิวอาร์โค้ดจาก Bottom Menu</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent">เมื่อทาง OneChat ได้รับข้อความจาก ผู้ใช้ที่ทำการส่งถึงบอทที่ลงทะเบียน webhook กับทางเรา เราจะส่งข้อมูลที่จำเป็นไปยัง webhook ตามข้อมูลต่อไปนี้</p>
    </div>
    <span class="mb-2">ตัวอย่างรูปแบบ Webhook ที่ Bot จะได้เมื่อ User scan Qrcode</span>
<div>
    <code class="codecolormo mt-2" style="">
        <v-tooltip top >
<v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"Ua521xx18350a5xxx2bxxxxx"</span>,
    <span class="colorkey">"event"</span> : <span class="colorvalue">"qrcode"</span>,
    <span class="colorkey">"timestamp"</span> : <span class="colorvalue">"1462629479859"</span>,
    <span class="colorkey">"source"</span> : {
        <span class="colorkey">"type_source"</span> : <span class="colorvalue">"user"</span>,
        <span class="colorkey">"user_id"</span> : <span class="colorvalue">"R5b1fxxxxxx94fxxxxx594xxxxe763xxxx"</span>,
        <span class="colorkey">"one_id"</span> : <span class="colorvalue">"123xxxx"</span>,
        <span class="colorkey">"email"</span> : <span class="colorvalue">"onechat@one.th"</span>,
        <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>
    },
    <span class="colorkey">"data"</span> : <span class="colorvalue">"Hello"</span>
  }
      </code>
       <h3>รายละเอียดข้อมูลที่ได้รับ</h3>
             <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของ Bot ที่เป็นผู้รับ Webhook ที่ส่งไปให้</td>
        </tr>
        <tr>
          <td>event</td>
          <td>String</td>
          <td>ชื่อการกระทำของ User ที่ทำให้เกิด Webhook<br>
          <!-- <ul>  <li>add_friend เป็นอีเว้นท์เมื่อมีการเพิ่มเพื่อนกับบอท</li></ul> -->
          </td>
        </tr>
        <tr>
          <td>timestamp</td>
          <td>Integer</td>
          <td>เวลาที่ส่ง Webhook</td>
        </tr>
        <tr>
          <td>source</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลของ user ที่สแกน ประกอบด้วยข้อมูลดังนี้
            <ul>
                <li>type_source ชนิดของผู้ใช้ ซึ่งจะเป็น user</li>
                <li>user_id คือรหัสเฉพาะของผู้ใช้ในระบบ Onechat</li>
                <li>one_id คือ OneID ของผู้ใช้</li>
                <li>email คืออีเมล์ของผู้ใช้</li>
                <li>display_name คือชื่อของผู้ใช้ที่แสดงงในระบบ Onechat</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>data</td>
          <td>String</td>
          <td> ข้อมูลที่อ่านได้จากการสแกน QrCode</td>
        </tr>
      </table>
    </div>
</div>
</div>
</template>
<script type="text/javascript">
export default {
  data: () => ({
    active: null,
    message: '{\n\t"bot_id" : "Ua521xx18350a5xxx2bxxxxx",\n\t"event" : "qrcode",\n\t"timestamp" : 1462629479859,\n\t"source" : {\n\t\t"type_source" : "user",\n\t\t"user_id" : "R5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t\t"one_id" : "123xxxx",\n\t\t"email" : "onechat@one.th",\n\t\t"display_name" : "One Chat"\n\t},\n\t"data":"Hello"\n}',
    // messagegroup: '{\n\t"event" : "message",\n\t"bot_id" : "Ua521xx18350a5xxx2bxxxxx",\n\t"timestamp" : 1462629479859,\n\t"message" : {\n\t\t"id" : "1",\n\t\t"type" : "text",\n\t\t"text" : "Hello, world"\n\t},\n\t"source" : {\n\t\t"type_source" : "group",\n\t\t"group_id" : "G5b1fxxxxxx94xxxxe763xxxx",\n\t\t"group_name" : "Test Bot",\n\t\t"sender" : {\n\t\t\t"user_id" : "R5b1fxxxxxx94fxxxxx594xxxxe763xxxx",\n\t\t\t"display_name" : "One Chat",\n\t\t\t"email" : "onechat@one.th"\n\t\t}\n\t}\n}'
    // ]
  })
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
  max-height: 60vh;
  overflow-y: scroll;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 100%;
  max-height: 60vh;
  overflow-y: scroll;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
}
#apimsgtable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 50vw;
}

#apimsgtable td, #apimsgtable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtable tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtable tr:hover {background-color: #ddd;}

#apimsgtable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
.requestmessage {
    display: none !important;
}

.codecolor:hover .requestmessage {
    display: block !important;
}

.urlcopymessage {

    display: none !important;
}
.EndpointUrl:hover .urlcopymessage {
    display: inline !important;
}
.requestmessageresponse{
    display: none !important;
}

.codecolor:hover .requestmessageresponse {
    display: block !important;
}
.cschatthai {
  font-family: 'CS ChatThaiUI' !important;
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/webhook/recieveqrcodebottommenu.vue